"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sliceKey = exports.reducer = exports.captchaContainerActions = exports.initialState = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const betweb_openapi_axios_1 = require("betweb-openapi-axios");
const REDUCER_KEY = 'captchaContainerState';
exports.initialState = {
    activeCaptchaProvider: '',
    captchaProviders: [],
};
const captchaContainerSlice = (0, toolkit_1.createSlice)({
    name: REDUCER_KEY,
    initialState: exports.initialState,
    reducers: {
        fetchCaptchaProviders() { },
        fetchCaptchaProvidersSuccess(state, { payload }) {
            state.captchaProviders = payload.items;
        },
        setGoogleCaptchaInfo(state, { payload }) {
            state.googleCaptchaInfo = payload;
            state.activeCaptchaProvider = betweb_openapi_axios_1.CaptchaProviderType.Google;
        },
        setYandexCaptchaInfo(state, { payload }) {
            state.yandexCaptchaInfo = payload;
            state.activeCaptchaProvider = betweb_openapi_axios_1.CaptchaProviderType.Yandex;
        },
        setHuaweiCaptchaInfo(state, { payload }) {
            state.huaweiCaptchaInfo = payload;
            state.activeCaptchaProvider = betweb_openapi_axios_1.CaptchaProviderType.Huawei;
        },
        reset(state) {
            state.activeCaptchaProvider = '';
            state.googleCaptchaInfo = undefined;
            state.yandexCaptchaInfo = undefined;
            state.huaweiCaptchaInfo = undefined;
        },
    },
});
exports.captchaContainerActions = captchaContainerSlice.actions, exports.reducer = captchaContainerSlice.reducer, exports.sliceKey = captchaContainerSlice.name;
//# sourceMappingURL=slice.js.map